/* eslint-disable */
export default {
  copyToClipboard: 'Copier dans le presse-papiers',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
